import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Rx from 'rxjs/Rx';
import { Http, Headers, Response } from '@angular/http';
import { UtilService } from './util.service';


@Injectable()
export class GetJsonService {

  constructor(private http: Http, private utilService: UtilService) { }

  public getJSON(path: string, fileName: string) {
    return this.http.get(path + fileName)
    .map(res => res.json())
    .catch(this.utilService.handleError);
      // .map((response: Response) => response.json());
  }
  private handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

}







// WEBPACK FOOTER //
// ./src/app/shared/_services/get-json.service.ts